import type { Project } from './projects.types';
import mascotacoolPrincipal from '../assets/projects/mascotacool-principal.jpg';
import mascotacoolInicio from '../assets/projects/mascotacool-inicio.jpg';
import alquilerE312 from '../assets/projects/alquiler-e312.jpg';
import tangareRegistro from '../assets/projects/tangare-registro.jpg';

export const projects: Project[] = [
  {
    id: 'mascotacool-principal',
    title: 'MascotaCool Principal',
    description: 'E-commerce platform for pet products with real-time inventory',
    longDescription: 'A full-stack e-commerce solution built for the Ecuadorian pet market. Features real-time inventory management, integrated payment gateways (local and international), automated order processing, and a comprehensive admin dashboard. Built with React, Node.js, and PostgreSQL, deployed on Render with CI/CD pipelines.',
    tags: ['React', 'Node.js', 'PostgreSQL', 'TailwindCSS', 'Stripe', 'Render'],
    image: mascotacoolPrincipal,
    liveUrl: 'https://mascotacool.github.io/principal',
    repoUrl: 'https://github.com/MascotaCool/principal',
    featured: true,
    category: 'E-Commerce',
  },
  {
    id: 'mascotacool-inicio',
    title: 'MascotaCool Inicio',
    description: 'Landing page and brand experience for pet care services',
    longDescription: 'Modern, responsive landing page showcasing pet care services with animated transitions, service booking integration, testimonial carousel, and SEO-optimized structure. Built with vanilla JavaScript, GSAP animations, and deployed on GitHub Pages for maximum performance.',
    tags: ['Vanilla JS', 'GSAP', 'HTML5', 'CSS3', 'GitHub Pages'],
    image: mascotacoolInicio,
    liveUrl: 'https://mascotacool2020.github.io/inicio',
    repoUrl: 'https://github.com/MascotaCool2020/inicio',
    featured: true,
    category: 'Landing Page',
  },
  {
    id: 'alquiler-e312',
    title: 'Alquiler E312',
    description: 'Property rental management platform with automated workflows',
    longDescription: 'Comprehensive rental management system for property owners and tenants. Features automated contract generation, payment tracking, maintenance request system, document management, and notification engine. Built with React, TypeScript, and deployed on Render with PostgreSQL database.',
    tags: ['React', 'TypeScript', 'PostgreSQL', 'Render', 'Node.js', 'JWT'],
    image: alquilerE312,
    liveUrl: 'https://alquiler-e312.onrender.com',
    repoUrl: 'https://github.com/MascotaCool/alquiler-e312',
    featured: true,
    category: 'SaaS Platform',
  },
  {
    id: 'tangare-registro',
    title: 'Tangare Registro',
    description: 'Event registration and attendee management system',
    longDescription: 'Streamlined event registration platform with QR code check-in, automated email confirmations, badge generation, real-time attendance tracking, and analytics dashboard. Designed for conferences and workshops with multi-language support and customizable registration forms.',
    tags: ['React', 'Netlify', 'Firebase', 'QR Codes', 'Email Automation'],
    image: tangareRegistro,
    liveUrl: 'https://tangare-registro.netlify.app',
    repoUrl: 'https://github.com/MascotaCool/tangare-registro',
    featured: true,
    category: 'Event Tech',
  },
];